import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Search, Home } from 'lucide-react';
export function NotFoundPage() {
  return <section className="relative min-h-screen bg-navy-900 flex items-center justify-center overflow-hidden pt-20" data-id="element-1171">
      {/* Background 404 */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none opacity-10" data-id="element-1172">
        <span className="text-[12rem] md:text-[20rem] font-black text-white leading-none tracking-tighter" data-id="element-1173">
          404
        </span>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center" data-id="element-1174">
        <span className="inline-block text-cg-orange-600 font-bold uppercase tracking-widest text-sm mb-4 border border-cg-orange-600/30 bg-cg-orange-600/10 px-4 py-1 rounded-full" data-id="element-1175">
          Error 404
        </span>

        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-1176">
          Page Not Found
        </h1>

        <p className="text-lg md:text-xl text-steel-300 mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-1177">
          The page you are looking for does not exist or may have been moved.
          Please check the URL or navigate back to the site.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-1178">
          <Link to="/" className="inline-flex items-center justify-center px-8 py-4 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider rounded-sm transition-colors w-full sm:w-auto gap-2" data-id="element-1179">
            <Home className="w-4 h-4" data-id="element-1180" /> Return Home
          </Link>
          <Link to="/products" className="inline-flex items-center justify-center px-8 py-4 border border-white/30 hover:bg-white/10 text-white font-bold uppercase tracking-wider rounded-sm transition-colors w-full sm:w-auto gap-2" data-id="element-1181">
            <Search className="w-4 h-4" data-id="element-1182" /> View Products
          </Link>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-steel-400" data-id="element-1183">
          <Link to="/contact" className="hover:text-white transition-colors" data-id="element-1184">
            Contact Us
          </Link>
          <span className="text-white/20 hidden sm:inline" data-id="element-1185">•</span>
          <Link to="/sectors" className="hover:text-white transition-colors" data-id="element-1186">
            View Sectors
          </Link>
          <span className="text-white/20 hidden sm:inline" data-id="element-1187">•</span>
          <Link to="/frameworks" className="hover:text-white transition-colors" data-id="element-1188">
            Frameworks
          </Link>
        </div>
      </div>
    </section>;
}